import { CustomSelect, selectedTokens } from '@leedpulse-monorepo/components';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { useContext, useEffect, useMemo } from 'react';
import type { ComponentProps } from 'react';
import DomainsContext from '../../../contexts/data/DomainsContext';
import domainSelectOptions from './domainSelectOptions';

type CustomSelectProps = ComponentProps<typeof CustomSelect>;

export type DomainsSelectProps = Omit<CustomSelectProps, 'options'> & {
  archived?: boolean;
};

/**
 * CustomSelect over the domains of DomainsContext (no Algolia index on Domains), loaded in full
 * on mount. Archived domains are left out like in DebouncedPlansSelect.
 */
export default function DomainsSelect({ archived = false, value, ...selectProps }: DomainsSelectProps) {
  const domainsContext = useContext(DomainsContext);

  // Always reloads: the shared context can be in SUCCESS with no items (fetchBySubscription)
  useEffect(() => {
    domainsContext.fetch(true);
  }, []);

  const selected = useMemo(() => selectedTokens(value), [value]);

  const options = useMemo(
    () => domainSelectOptions(domainsContext.items, archived, selected),
    [domainsContext.items, archived, selected]
  );

  return (
    <CustomSelect
      {...selectProps}
      value={value}
      customOptions={false}
      optionFilterProp="label"
      options={options}
      loading={domainsContext.status === ContextStatus.LOADING}
    />
  );
}